import { render } from "./IconBar.vue?vue&type=template&id=4bbf92a2&ts=true"
import script from "./IconBar.vue?vue&type=script&lang=ts"
export * from "./IconBar.vue?vue&type=script&lang=ts"

import "./IconBar.vue?vue&type=style&index=0&id=4bbf92a2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__